import { render } from "./FinalSetupComponent.vue?vue&type=template&id=95c09164"
import script from "./FinalSetupComponent.vue?vue&type=script&lang=js"
export * from "./FinalSetupComponent.vue?vue&type=script&lang=js"

import "./FinalSetupComponent.vue?vue&type=style&index=0&id=95c09164&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__